var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgThumbShine = function SvgSvgThumbShine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.75,
    cy: 6.75,
    r: 2.25,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.75,
    cy: 2.25,
    r: 2.25,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.75,
    cy: 4.25,
    r: 2.25,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.75,
    cy: 8.75,
    r: 2.25,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 17.688c.38 0 .732.22 1 .5.268.279.5 0 .5.5 0 .395-.14 1.048-.41 1.328-.268.28-.574.422-.954.422l-1.431.062c.38 0 .744.236 1.012.516s.42.776.42 1.172c0 .395-.152.774-.42 1.053-.268.28-.633.437-1.012.437H10.5c-3.818 0-2.364-2.478-10-2.478V12.26h2.364c1.945-.115 3.774-1.005 5.107-2.484 1.332-1.48 2.044-3.06 2.029-5.088 0-1.57 2.886-2.146 2.886.834-.146 1.942-.397 4.287-.886 6.167h7.5c.38 0 .5 0 1.08.013.27.28.92.591.92.986 0 .396-.232 1.221-.5 1.5-.268.28-.62.5-1 .5h-1c.38 0 .732.034 1 .313.268.28.5.188.5.688 0 .395-.232 1.22-.5 1.5-.268.279-.62.5-1 .5h-1Z",
    fill: "#D6FFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 12.5h2a7.949 7.949 0 0 0 7.5-8c0-1.581 3-1.781 3 1.219a31.595 31.595 0 0 1-1 5.781h8a1.5 1.5 0 1 1 0 3h-1a1.5 1.5 0 1 1 0 3h-1M18 17.5a1.5 1.5 0 1 1 0 3h-1a1.5 1.5 0 1 1 0 3h-6.5c-4 0-2-2-10-2M3.5 7.5v-2M2.5 6.5h2M7.5 2.5v-2M6.5 1.5h2M17.5 4.5v-2M16.5 3.5h2M22.5 9.5v-2M21.5 8.5h2",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSvgThumbShine;